import Vue from "vue";

const getDefaultState = () => {
  return {
    PresencesDotationsDeGroupeDeSuperviseur: [],
    PresencesDotationsDeGroupe: [],
    //field: "name",
    whereField: "id_responsable",
    //whereValue: "superviseur",
    collection: "presencesDotationsGroupes",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE_DU_SUPERVISEUR(state, payload) {
    state.PresencesDotationsDeGroupeDeSuperviseur = payload;
  },
  SET_LISTE_DE_DOTATION(state, payload) {
    state.PresencesDotationsDeGroupe = payload;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_ONE_ITEM(state, payload) {
    state.PresencesDotationsDeGroupeDeSuperviseur.push(payload);
    state.PresencesDotationsDeGroupe.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM", item);
    console.log("added to Vuex PresencesDotationsDeGroupe", item)
  },
  async GetSuperviseurPresencesDotationsDeGroupe({ commit, dispatch }, objet) {
    // start requête
    commit("SET_LISTE_DU_SUPERVISEUR", []);
   
    commit(
      "Loading/START_BUSY_STATE",
      "PresencesDotationsDeGroupe GetSuperviseurPresencesDotationsDeGroupe",
      {
        root: true,
      }
    );
    let elems = [];
    await this._vm.$firebase
      .firestore()
      .collection(this.state.PresencesDotationsDeGroupe.collection)
      .where("id_responsable", "==", objet.userId)
      .where("programmes_id_programme", "==", objet.project.id)
      .where("date_dotation_groupe", ">=", objet.start)
      .where("date_dotation_groupe", "<=", objet.end)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE_DU_SUPERVISEUR", elems);
            commit(
              "Loading/END_BUSY_STATE",
              "PresencesDotationDesGroupe.store.js",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "PresencesDotationsDeGroupe.store.js",
            {
              root: true,
            }
          );
        }
      );
  },
  async GetPresencesDotationsDeGroupeByIdDotation(
    { commit, dispatch },
    idDotation
  ) {
    // start requête
    commit("SET_LISTE_DE_DOTATION", []); 
    commit(
      "Loading/START_BUSY_STATE",
      "PresencesDotationsDeGroupe GetPresencesDotationsDeGroupeByIdDotation",
      {
        root: true,
      }
    );
    let elems = [];

    await this._vm.$firebase
      .firestore()
      .collection("presencesDotationsGroupes")
      .where("dotations_groupes_id_dotation_groupe", "==", idDotation)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE_DE_DOTATION", elems);

            commit(
              "Loading/END_BUSY_STATE",
              "PresencesDotationDesGroupe.store.js GetPresencesDotationsDeGroupeByIdDotation",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit(
            "Loading/END_BUSY_STATE",
            "PresencesDotationsDeGroupe.store.js GetPresencesDotationsDeGroupeByIdDotation",
            {
              root: true,
            }
          );
        }
      );
  },
};

const getters = {
  PresencesDotationsDeGroupeDeSuperviseur: (state) => {
    return state.PresencesDotationsDeGroupeDeSuperviseur;
  },
  PresencesDotationsDeGroupe: (state) => {
    return state.PresencesDotationsDeGroupe;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
